import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styles from "./Footer.module.scss";

const Footer = () => {
  const { t } = useTranslation();
  const publicUrl = process.env.PUBLIC_URL || "";
  const associationLinks = [
    {
      href: `${publicUrl}/files/23.02.2025_Statut_Stowarzyszenia.pdf`,
      label: t("footer_bylaws"),
      target: "_blank",
      rel: "noopener noreferrer",
    },
    {
      href: `${publicUrl}/files/Regulamin_WHC.docx`,
      label: t("footer_membership_rules"),
      download: true,
    },
    {
      href: `${publicUrl}/files/Deklaracja_Członkowska_Warsaw_Hockey_Club.pdf`,
      label: t("footer_membership_pledge"),
      target: "_blank",
      rel: "noopener noreferrer",
    },
  ];

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.left}>
          <h2>{t("club_name")}</h2>
          <p>{t("footer_slogan")}</p>
        </div>

        <div className={styles.right}>
          <div className={styles.footerWrapper}>
            <ul className={styles.links}>
              <li>
                <Link to="/about">{t("nav_about")}</Link>
              </li>
              <li>
                <a href="/about#trainings">{t("nav_training")}</a>
              </li>
              <li>
                <Link to="/news">{t("nav_news")}</Link>
              </li>
              <li>
                <Link to="/gallery">{t("nav_gallery")}</Link>
              </li>
              <li>
                <Link to="/league">{t("nav_league")}</Link>
              </li>
              <li>
                <Link to="/contact">{t("nav_contact")}</Link>
              </li>
            </ul>

            <div className={styles.contact}>
              <p>
                Email: <a href="mailto:mail@warsawhockeyclub.pl">mail@warsawhockeyclub.pl</a>
              </p>
              <p>{t("footer_address")}</p>
            </div>
          </div>

          <div className={styles.footerWrapper}>
            <h6>{t("footer_association")}</h6>
            <div className={styles.wrapperLinks}>
              {associationLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  target={link.target}
                  rel={link.rel}
                  download={link.download}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className={styles.bottom}>
        <p>
          © {new Date().getFullYear()} {t("club_name")} - {t("footer_rights")}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
